export const parseRestErrorMessage = (error: unknown, defaultMessage: string): string => {
    const rawMessage = error instanceof Error ? error.message : String(error);

    try {
        const parsed = JSON.parse(rawMessage);
        const message = parsed?.errors ? parsed.errors[0]?.message : parsed.message;
        return message || defaultMessage;
    } catch {
        return rawMessage || defaultMessage;
    }
};
